import useBloqueioAreaComumColumns from "features/area-comum/hooks/useBloqueioAreaComumColumns";
import useDeletarBloqueioUnidade from "features/area-comum/hooks/useDeletarBloqueioUnidade";
import useUnidadesBloqueadas from "features/area-comum/hooks/useUnidadesBloqueadas";
import { AreaComumUnidadeBloqueadaItem } from "features/area-comum/typings";
import { useBreadcrumb } from "features/breadcrumbs";
import useFiltro from "infra/helpers/useFiltro";
import { useEffect, useState } from "react";
import NewTable from "components/NewTable";
import PageHeader from "components/Page/PageHeader";
import ModalBloqueioUnidadeAreaComum from "./components/ModalBloqueioUnidadeAreaComum";
import Container from "components/Container";
import { showSuccess } from "infra/helpers/alerta";

function AreaComumBloqueioUnidadePage() {
  const [editId, setEditId] = useState<string | undefined>();
  const [modalOpen, setModalOpen] = useState(false);
  const { filtro, onChangeFiltro } = useFiltro();

  const { isLoading, isFetching, data, refetch } = useUnidadesBloqueadas({
    page: filtro.page || 1,
    limit: filtro.limit,
    search: filtro.search,
  });

  const { mutate: deletarBloqueio, isLoading: isLoadingDeletar } =
    useDeletarBloqueioUnidade();

  const columns = useBloqueioAreaComumColumns();

  useBreadcrumb([
    { name: "Cadastros", url: "/cadastros" },
    { name: "Áreas comuns", url: "/cadastros/areas-comum" },
    { name: "Unidades bloqueadas", url: "/cadastros/areas-comum/bloqueio" },
  ]);

  const onClose = () => {
    setModalOpen(false);
  };

  useEffect(() => {
    if (editId) {
      setModalOpen(true);
    }
  }, [editId]);

  useEffect(() => {
    if (!modalOpen) {
      setEditId(undefined);
    }
  }, [modalOpen]);

  const _isLoading = isLoading || isLoadingDeletar || isFetching;

  return (
    <Container>
      <ModalBloqueioUnidadeAreaComum
        visible={modalOpen}
        onClose={onClose}
        onSaved={() => {
          showSuccess().then(() => {
            refetch();
            onClose();
          });
        }}
        editId={editId}
      />
      <PageHeader
        onClick={() => setModalOpen(true)}
        title="Unidades bloqueadas"
        titleButton="Bloquear nova unidade"
      />

      <NewTable<AreaComumUnidadeBloqueadaItem>
        loading={_isLoading}
        columns={columns}
        dataSource={data?.items ?? []}
        customPagination={{
          currentPage: data?.meta.currentPage ?? 0,
          totalItems: data?.meta.totalItems ?? 0,
          itemsPerPage: data?.meta.itemsPerPage ?? 0,
          onChangePage: (p) => onChangeFiltro("page", p),
        }}
        actions={[
          {
            title: "Editar",
            onClick: (v) => {
              setEditId(v.id);
            },
          },
          {
            title: "Excluir",
            onClick: (v) => {
              deletarBloqueio(v.id, {
                onSuccess: () => refetch(),
              });
            },
          },
        ]}
      />
    </Container>
  );
}

export default AreaComumBloqueioUnidadePage;
